//中文
export default {
  inputPlaceholder: '请输入',
  selectPlaceholder: '请选择',
  checkAll:"全选",
  save:"保存"
}